angular.module('myFeedBackModule',[]).
controller("myFeedBackCtrl",["$scope", "$modalInstance", "trsHttpService", "$q",
    function($scope,$modalInstance,trsHttpService,$q){

    initStatus()
    getData()
	/**
     * [initStatus description] 初始化状态
     * @return {[type]} [description]
     */
    function initStatus() {
        $scope.status = {
            itemData:[],
        };
        $scope.data = {
        };
    }
    /**
     * [getData description] 获取我的反馈数据
     * @param  {[type]}  [description]
     * @return {[type]} [description]
    */
    function getData(){
        var deffer = $q.defer();
        $scope.params = {
            serviceid: "mlf_feedback",
            methodname: 'queryHistioryFeedBack',
        }
        $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), $scope.params, "get").then(function(res) {
            $scope.status.itemData = res;
        });
        return deffer.promise;
    }
     /**
     * [cancel description] 取消
     * @return {[type]} [description]
     */
    $scope.cancel = function() {
        $modalInstance.close('cancel');
    };


}]);